import API from "../../api";

export const postAgencyLinkingDetails = data =>
  API.agent().post(`/linking-agreement`, data);
